// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-control[data-v-75c2462a]{height:40px}", "",{"version":3,"sources":["webpack://./resources/components/filters/RoleFilter.vue"],"names":[],"mappings":"AAIA,+BACE,WAHF","sourcesContent":["@import \"../../scss/variables/color\";\n@import \"../../scss/variables/container-max-widths\";\n\n\n.form-control {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
